module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("ToDo")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n    Nicht fertig\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4733ed06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/todosEigene.vue
// module id = 771
// module chunks = 15